import i18n from "features/Languages/i18n"
import { DEVICE_TYPE_DESKTOP } from "./constants";

export const getSocialAppLoginUrl = () => {    
    return `${process.env.REACT_APP_SOCIAL_APP_URL}`
}

export const isMobileDevice = (deviceType) => deviceType === DEVICE_TYPE_DESKTOP ? false : true;